//@flow

import type { Error } from 'error';

const CAPTCHA_VALIDATION_EXCEPTION = 'CaptchaValidationException';
const KBM_SECURITY_EXCEPTION = 'KbmSecurityException';
const INVALID_EMAIL_FORMAT_EXCEPTION = 'InvalidEmailFormatException';
const PAYMENT_UNAVAILABLE_EXCEPTION = 'PaymentUnavailableException';
const ORDER_IS_OBSOLETE_REQUEST_FORBIDDEN_EXCEPTION = 'OrderIsObsoleteRequestForbiddenException';

const HTTP_ERROR = 'HttpError';
const GATEWAY_TIMEOUT = 'Gateway Timeout';
const UNEXPECTED_STATUS = 'UnexpectedStatus';

//Хелпер для проверки известных типов ошибок
export class KnownErrorsHelper {
	static isCaptchaValidationError = (e: Error) => {
		return e.name === CAPTCHA_VALIDATION_EXCEPTION;
	};

	static isKbmSecurityError = (e: Error) => {
		return e.name === KBM_SECURITY_EXCEPTION;
	}

	static isInvalidEmailFormatError = (e: Error): boolean => {
		return e.name === INVALID_EMAIL_FORMAT_EXCEPTION;
	};

	static isPaymentUnavailableError = (e: Error): boolean => {
		return e.name === PAYMENT_UNAVAILABLE_EXCEPTION;
	};

	static isHttpError = (e: Error) => {
		return e.name === HTTP_ERROR;
	};

	//TODO: убедиться, что надо использовать message, а не name
	static isGatewayTimeout = (e: Error) => {
		return e.message === GATEWAY_TIMEOUT;
	};

	static isUnexpectedStatus = (e: Error) => {
		return e.name === UNEXPECTED_STATUS;
	};

	static isOrderStatusObsoleteError = (e: Error): boolean => {
		return e.name === ORDER_IS_OBSOLETE_REQUEST_FORBIDDEN_EXCEPTION;
	}
}